import React from 'react';
import { Badge, Col, Row } from 'antd';

import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import ActionBox from './action-box';

import menu from '../icons/menu.png';

const DragHandle = SortableHandle(() => <span><img alt="drag handle" className="drag-handle" src={menu} /></span>);

const SortableItem = SortableElement(({
    featuredCategory,
    index,
    onDelete,
    onEdit, 
    position, 
    toggleActive
}) => {

    const { active } = featuredCategory;
    return (
        <div className="featured-category-container">
           
            <li style={{listStyle: "none", height: '100%'}}>
                <Row 
                    type="flex" 
                    align="center"
                    style={{height: '100%'}}
                    >
                    
                    <Col 
                        style={{alignSelf: 'center'}} 
                        span={1}>
                        <Badge status={(active)? 'success' : 'default'}/>
                    </Col>

                    <Col 
                        style={{alignSelf: 'center'}} 
                        span={1}>
                        <DragHandle />
                    </Col>

                    <Col 
                        span={17}
                        style={{alignSelf: 'center'}}
                        >
                        {featuredCategory.title}
                    </Col>

                    <Col 
                        span={4}
                        style={{alignSelf: 'center'}}
                        >
                        <ActionBox 
                            active={active}
                            onDelete={onDelete}
                            onEdit={onEdit}
                            toggleActive={toggleActive}
                            position={position}
                            />
                    </Col>

                </Row>
                
            </li>
               
        </div>
    );
  });
  
const SortableList = SortableContainer(({
      featuredCategories, 
      onDelete, 
      onEdit, 
      toggleActive
    }) => {


        return (
        <ul>
            {featuredCategories.map((featuredCategory, index) => {
                const { position, title } = featuredCategory;
                return (
                    <SortableItem 
                        key={`${title}`} 
                        index={index} 
                        position={position}
                        featuredCategory={featuredCategory}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        toggleActive={toggleActive}
                        />
                )
            })}
        </ul>
        );
    }
);
  
class SortableFeaturedList extends React.Component {

    render() {

        if(!this.props.featuredCategories) {
            return <div> No featured Categories</div>
        }

        if(this.props.featuredCategories) {
            const { featuredCategories } = this.props || [];

            return (
                <div className="featured-categories-container">
                    <SortableList 
                        onSortEnd={this.onSortEnd}
                        useDragHandle={true}
                        featuredCategories={featuredCategories}
                        onDelete={this.onDelete}
                        onEdit={this.props.onEdit}
                        toggleActive={this.props.toggleActive}
                        />
                </div>
            )
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            featuredCategories: false
        }
    }

    componentWillMount() {
        const { featuredCategories } = this.props;
        this.setState({
            featuredCategories
        })
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.featuredCategories !== nextProps.featuredCategories) {
            this.setState({
                featuredCategories: nextProps.featuredCategories
            })
        }
    }

    move(array, from, to) {
        array.splice(to, 0, array.splice(from, 1)[0]);
        array.map(
            (elem, i) =>  {
                elem.position = i 
                return elem;
            }
        );
        // array.map(
        //     indv => {
        //         console.log(indv.position)
        //     }
        // )
        return array;
    };

    onDelete = (position) => {
        const { featuredCategories } = this.state;
        const array = this.state.featuredCategories;

        if ( position === featuredCategories.length-1) {
            array.pop()

        } else {
            array.splice(position, 1);


            for( let i = position; i<array.length; i++) {
                array[i].position--;
            }
        }

        this.setState({
            featuredCategories: array
        })
        this.props.updateEdited()

    }   

    onSortEnd = ({oldIndex, newIndex}) => {

        const categoryArray = this.state.featuredCategories;
        this.move(categoryArray, oldIndex, newIndex);

        this.setState({
            featuredCategories: categoryArray
        })
        this.props.updateEdited()

        this.updateFeaturedCategories(this.state.featuredCategories)
    };


    updateFeaturedCategories = () => {
            this.props.updateFeaturedCategories(this.state.featuredCategories)

    }
}

export default SortableFeaturedList;



// WEBPACK FOOTER //
// ./src/components/featured/sortable-featured-list/index.js